import { PlessHttp } from './../../../../shared/http/pless-http.service';
import { Component, OnInit, AfterViewInit, Input, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { GetMarkListService } from './api-services/get-mark-list.service';
import { MarkCodeTextInputModel } from './mark-code-text-input.model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * マークコードテキストインプットクラス
 *
 * @export MarkCodeTextInputComponent
 * @class MarkCodeTextInputComponent
 */
@Component({
  selector: 'app-mark-code-text-input',
  templateUrl: 'mark-code-text-input.component.html',
  styleUrls: ['mark-code-text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: MarkCodeTextInputComponent,
      multi: true,
    },
    {
      provide: GetMarkListService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => {
        return new GetMarkListService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub]

    },
  ]
})
export class MarkCodeTextInputComponent implements OnInit, AfterViewInit, OnChanges, ControlValueAccessor {

  /** テキストインプットの参照 */
  @ViewChild('inputText', { static: true }) private inputText: ElementRef;
  @Input() public subid: string = null;
  /** 値 */
  @Input() text: string = null;
  /** 初期フォーカス項目 */
  @Input() initFocusItem: any = null;
  /** マーク名称フィールド */
  @Input() public markNameField: any = null;

  // レイアウト系の変数
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number | string;
  @Input() height: number = <number>20;
  @Input() fontSize: number = <number>9;
  @Input() editable: boolean = <boolean>true;
  @Input() tabindex: number = null;
  @Input() tabEnabled: boolean = <boolean>true;
  @Input() forcedEnabledMode: string = null;
  @Input() required: boolean = <boolean>false;
  @Input() maxChars: number = <number>3;
  @Input() restrict: string = <string>'[0-9]';
  @Input() autofocus: boolean = <boolean>false;
  @Input() afterFocus: any = null;                                              // ロード完了後フォーカスを移動させるid

  /** マークコード */
  public selectedMarkCode: string = null;
  /** マーク名称 */
  public selectedMarkName: string = null;
  /** マークグループコード */
  public selectedMarkGroupCode: string = null;
  /** 供給促進マーク区分 */
  public selectedSupplyPromoteMarkDiv: string = null;

  /** マークコードテキストインプットモデル */
  public model: MarkCodeTextInputModel = new MarkCodeTextInputModel();

  // ValueAccessor
  @Input() disabled: boolean = <boolean>false;
  onChange(obj: any): void { }
  onTouched(): void { }
  writeValue(text: string): void {
    if (text !== this.text) {
      this.text = text;
      if (this.model.completeUpdateMarkCodeList) {
        // 変更イベント処理実行
        this.changeMarkCodeHandler();
      }
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * Creates an instance of MarkCodeTextInputComponent.
   * private getMarkListService: GetMarkListService,
   * @param {GetMarkListService} getMarkListService マークコードリストを取得する
   * @memberof CatalogProgressTextInputComponent
   */
  constructor(
    private getMarkListService: GetMarkListService,
    public elementRef: ElementRef
  ) {
  }

  /**
   * 初期化処理
   *
   * @memberof MarkCodeTextInputComponent
   */
  ngOnInit(): void {
    this.inputText.nativeElement.setAttribute('id', this.subid + '_sub');
    this.inputText.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof MarkCodeTextInputComponent
   */
  ngAfterViewInit(): void {
    // テキストインスタンス設定
    this.model.markCodeTextInput = this;

    // イベント発行
    this.getMarkListService.execute(this.model, null);
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof MediaGroupComboBoxComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'text':
          this.text = changes.text.currentValue;

          if (changes.text.currentValue != null && changes.text.currentValue.length > 0) {
            this.text = PlessViewUtilsSub.padding(changes.text.currentValue, 3, '0', 1);
          } else {
            this.text = '';
          }
          if (this.model.completeUpdateMarkCodeList) {
            // 変更イベント処理実行
            this.changeMarkCodeHandler();
          }
          break;
      }
    });
  }

  /**
   * マークコード有効有無を返却する
   *
   * @return boolean:True有効、False無効
   */
  public isValidMarkCode(): boolean {
    if (this.selectedMarkName.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * マークコード変更時の処理を行う。
   */
  public changeMarkCodeHandler(): void {
    if (this.markNameField != null) {
      if (this.markNameField.constructor === HTMLLabelElement) {
        this.markNameField.innerText = '';
      } else if (this.markNameField.constructor === HTMLInputElement) {
        this.markNameField.value = '';
      } else if (this.markNameField.constructor === HTMLTextAreaElement) {
        this.markNameField.value = '';
      }
    }
    this.selectedMarkCode = '';
    this.selectedMarkName = '';
    this.selectedMarkGroupCode = '';
    this.selectedSupplyPromoteMarkDiv = '';

    let chkCode = String('');
    if (!PlessViewUtilsSub.isEmpty(this.text)) {
      chkCode = PlessViewUtilsSub.padding(this.text, 3, '0', 1);
    }

    for (let i: number = <number>0; i < this.model.markList.length; i++) {
      if (this.model.markList[i].MarkCode === chkCode) {

        this.selectedMarkCode = this.model.markList[i].MarkCode;
        this.selectedMarkName = this.model.markList[i].MarkName;
        this.selectedMarkGroupCode = this.model.markList[i].MarkGroupCode;
        this.selectedSupplyPromoteMarkDiv = this.model.markList[i].SupplyPromoteMarkDiv;

        // markNameFieldが設定されてない場合は処理を中断する
        if (this.markNameField != null) {
          if (this.markNameField.constructor === HTMLLabelElement) {
            this.markNameField.innerText = this.model.markList[i].MarkName;
          } else if (this.markNameField.constructor === HTMLInputElement) {
            this.markNameField.value = this.model.markList[i].MarkName;
          } else if (this.markNameField.constructor === HTMLTextAreaElement) {
            this.markNameField.value = this.model.markList[i].MarkName;
          }
        }
        return;
      }
    }
    if (this.initFocusItem != null) {
      if (this.initFocusItem instanceof HTMLElement) {
        this.initFocusItem.focus();
      } else {
        // 参照先の型がElementでない(Component)ならComponent内の要素を見て最初のinput,textarea,selectElementにフォーカスをあてる
        for (const child of this.initFocusItem.elementRef.nativeElement.children) {
          if (child instanceof HTMLInputElement || child instanceof HTMLTextAreaElement || child instanceof HTMLSelectElement) {
            child.focus();
            break;
          }
        }
      }
      this.initFocusItem = null;
    }
  }

  /**
   * setFocusOverride※テキスト選択解除の為
   */
  setFocus(): void {
    this.inputText.nativeElement.focus();
  }

  /**
   * フォーカスアウトイベント
   */
  blurHandler(event: any) {
    // マークコードのパディング
    if (this.model.completeUpdateMarkCodeList) {
      if (this.text.length > 0) {
        this.text = PlessViewUtilsSub.padding(this.text, 3, '0', 1);
        setTimeout(() => {
          event.relatedTarget.focus();
        });
      }
    }
  }

}
